module.exports = __webpack_public_path__ + "img/defaultProductIco2.7c0882ed.png";